import { render, staticRenderFns } from "./searchResetButton.vue?vue&type=template&id=134305a0&scoped=true&"
import script from "./searchResetButton.vue?vue&type=script&lang=js&"
export * from "./searchResetButton.vue?vue&type=script&lang=js&"
import style0 from "./searchResetButton.vue?vue&type=style&index=0&id=134305a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134305a0",
  null
  
)

export default component.exports